module.exports = __webpack_public_path__ + "img/solution2.6be829c9.png";